export class NameValuePair {

    public Name: string = "";
    public Value: string = "";
}
